// "Provide context" — the conversation that fills in the story behind a bullet.
//
// Authenticated and user-scoped: the backend resolves the accomplishment inside
// the caller's own profile, so an id is only ever meaningful to its owner.
import { apiFetch } from '../utils/apiFetch';
import { API_URL } from '../config';

const BASE = `${API_URL}/api/profile/context`;

const jsonHeaders = { 'Content-Type': 'application/json' };

async function asJson(res) {
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Profile context API ${res.status}: ${text || res.statusText}`);
  }
  return res.json();
}

/** Which bullets have context and which don't — the profile page's work-list. */
export async function getContextCoverage() {
  return asJson(await apiFetch(`${BASE}/coverage`));
}

/** Open the conversation; returns the first question. */
export async function startContext(accomplishmentId) {
  const res = await apiFetch(`${BASE}/${encodeURIComponent(accomplishmentId)}/start`, {
    method: 'POST',
    headers: jsonHeaders,
  });
  return asJson(res);
}

/** One exchange. History is sent each turn — the backend holds no session. */
export async function contextTurn(accomplishmentId, message, history) {
  const res = await apiFetch(`${BASE}/${encodeURIComponent(accomplishmentId)}/turn`, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ message, history }),
  });
  return asJson(res);
}

/** Synthesise the conversation into the accomplishment's stored context. */
export async function saveContext(accomplishmentId, history, conversationId) {
  const res = await apiFetch(`${BASE}/${encodeURIComponent(accomplishmentId)}/save`, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ history, conversation_id: conversationId || null }),
  });
  return asJson(res);
}
